import {HttpClient} from "../../service/httpClient/HttpClient";

export class AppVersionService {

    constructor() {
        this.httpClient = new HttpClient()
    }


    getAppVersionList(page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `android-releases`,
                {
                    page, size
                }
            ).then(resolve).catch(reject)
        })
    }

    addNewAppVersion(
        name,
        versionNumber,
        latestValidVersionNumber,
        enabled,
        storePublished,
        mandatory,
        description
    ) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `languages/fa-rIR/android-releases`,
                {
                    "versionNumber": versionNumber,
                    "latestValidVersionNumber": latestValidVersionNumber,
                    "name": name,
                    "enabled": enabled,
                    "storePublished": storePublished,
                    "mandatory": mandatory,
                    "metaData": {
                        "description": description
                    }
                }
            ).then(resolve).catch(reject)
        })
    }

    getAppVersionDetail(appVersionId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `languages/fa-rIR/android-releases/${appVersionId}`
            ).then(resolve).catch(reject)
        })
    }

    uploadApkFile(apkFile, appVersionId, setUploadPercent,signal) {
        const options = {
            onUploadProgress: (progressEvent) => {
                const {loaded, total} = progressEvent;
                let percent = Math.floor((loaded * 100) / total)
                setUploadPercent(percent)
            }
        }

        let data = new FormData()
        data.append('file', apkFile)

        return new Promise((resolve, reject) => {
            new HttpClient(options, "multipart/form-data")
                .patch(
                    `android-releases/${appVersionId}/apks`,
                    {},
                    data,
                    {},
                    signal
                ).then(resolve).catch(reject)
        })
    }

    updateAppVersion(
        appVersionId,
        name,
        versionNumber,
        latestValidVersionNumber,
        enabled,
        storePublished,
        mandatory,
        description) {

        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `languages/fa-rIR/android-releases/${appVersionId}`,
                {
                    "versionNumber": versionNumber,
                    "latestValidVersionNumber": latestValidVersionNumber,
                    "name": name,
                    "enabled": enabled,
                    "storePublished": storePublished,
                    "mandatory": mandatory,
                    "metaData": {
                        "description": description
                    }
                }
            ).then(resolve).catch(reject)
        })
    }
}